var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21978 7.38761L11.8082 5.1512C12.1743 4.83356 11.985 4.21156 11.5051 4.18516L8.17176 3.97341C7.96972 3.96021 7.79295 3.82783 7.71721 3.62936L6.49245 0.347418C6.31568 -0.115806 5.69696 -0.115806 5.52019 0.347418L4.29543 3.61612C4.21968 3.81459 4.04292 3.94696 3.84088 3.96017L0.494874 4.17193C0.0150473 4.19842 -0.174326 4.8204 0.191817 5.13796L2.78023 7.36116C2.93172 7.49354 3.00746 7.71849 2.957 7.91697L2.11103 11.318C1.99741 11.7944 2.48984 12.1782 2.89384 11.9135L5.70954 10.0211C5.8863 9.90206 6.10093 9.90206 6.26512 10.0211L9.09344 11.9135C9.49753 12.1782 9.98996 11.7944 9.87626 11.318L9.03029 7.93021C8.99241 7.73174 9.05556 7.51999 9.21974 7.38761H9.21978Z",
    fill: "#12B2CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateIcon);
export default __webpack_public_path__ + "static/media/rate-icon.c1aaeaaca349a87c72fd5bdfefaf495b.svg";
export { ForwardRef as ReactComponent };